/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import SegmentationAction from '../../action/segmentation'
import SessionStore from '../../store/SessionStore'
import SegmentCategoriesStore from '../../store/segmentation/SegmentCategoriesStore'
import ListView from '../../view/pages/segmentation/ListView'

class ListContainer extends Component {
  static getStores() {
    return [SessionStore, SegmentCategoriesStore]
  }

  static calculateState(prevState, props) {
    return {
      session: SessionStore.getState(),
      segment_categories: SegmentCategoriesStore.getState(),
      ...props
    }
  }

  componentDidMount() {
    SegmentationAction.fetchAll()
  }

  render() {
    return ListView(this.state)
  }
}

export default withRouter(Container.create(ListContainer, { withProps: true }))
